import lakers from '../../../img/logos/lakers.png';
import bulls from '../../../img/logos/bulls.png';
import warriors from '../../../img/logos/warriors.png';
import cavaliers from '../../../img/logos/cavaliers.png';
import miami from '../../../img/logos/miami.png';
import ph76rs from '../../../img/logos/76rs.png';
import blazers from '../../../img/logos/blazers.png';
import bucks from '../../../img/logos/bucks.png';
import celtics from '../../../img/logos/celtics.png';
import clippers from '../../../img/logos/clippers.png';
import denver from '../../../img/logos/denver.png';
import grizzlies from '../../../img/logos/grizzlies.png';
import hawks from '../../../img/logos/hawks.png';
import hornets from '../../../img/logos/hornets.png';
import kings from '../../../img/logos/kings.png';
import knicks from '../../../img/logos/knicks.png';
import magic from '../../../img/logos/magic.png';
import mavericks from '../../../img/logos/mavericks.png';
import nets from '../../../img/logos/nets.png';
import okc from '../../../img/logos/okc.png';
import pacers from '../../../img/logos/pacers.png';
import pelicans from '../../../img/logos/pelicans.png';
import phoenix from '../../../img/logos/phoenix.png';
import pistons from '../../../img/logos/pistons.png';
import raptors from '../../../img/logos/raptors.png';
import rockets from '../../../img/logos/rockets.png';
import spurs from '../../../img/logos/spurs.png';
import timberwolves from '../../../img/logos/timberwolves.png';
import utah from '../../../img/logos/utah.png';
import wizards from '../../../img/logos/wizards.png';

const listTeams = {
  New_York_Knicks: {
    name: 'New York Knicks',
    image: knicks,
  },
  Lakers: {
    name: 'Los Angeles Lakers',
    image: lakers,
  },
  Chicago_Bulls: {
    name: 'Chicago Bulls',
    image: bulls,
  },
  Golden_State_Warriors: {
    name: 'Golden State Warriors',
    image: warriors,
  },
  Cavaliers: {
    name: 'Cleveland Cavaliers',
    image: cavaliers,
  },
  Miami_Heat: {
    name: 'Miami Heat',
    image: miami,
  },
  Philadelphia: {
    name: 'Philadelphia 76ers',
    image: ph76rs,
  },
  Portland: {
    name: 'Portland Trail Blazers',
    image: blazers,
  },
  Milwaukee_Bucks: {
    name: 'Milwaukee Bucks',
    image: bucks,
  },
  Boston_Celtics: {
    name: 'Boston Celtics',
    image: celtics,
  },
  Los_Angeles_Clippers: {
    name: 'Los Angeles Clippers',
    image: clippers,
  },
  Denver_Nuggets: {
    name: 'Denver Nuggets',
    image: denver,
  },
  Memphis_Grizzlies: {
    name: 'Memphis Grizzlies',
    image: grizzlies,
  },
  Atlanta_Hawks: {
    name: 'Atlanta Hawks',
    image: hawks,
  },
  Charlotte_Hornets: {
    name: 'Charlotte Hornets',
    image: hornets,
  },
  Sacramento_Kings: {
    name: 'Sacramento Kings',
    image: kings,
  },
  Orlando_Magic: {
    name: 'Orlando Magic',
    image: magic,
  },
  Dallas_Maverick: {
    name: 'Dallas Mavericks',
    image: mavericks,
  },
  Nets: {
    name: 'Brooklyn Nets',
    image: nets,
  },
  Oklahoma_City_Thunder: {
    name: 'Oklahoma City Thunder',
    image: okc,
  },
  Indiana_Pacers: {
    name: 'Indiana Pacers',
    image: pacers,
  },
  New_Orleans_Pelicans: {
    name: 'New Orleans Pelicans',
    image: pelicans,
  },
  Phoenix_Suns: {
    name: 'Phoenix Suns',
    image: phoenix,
  },
  Detroit_Pistons: {
    name: 'Detroit Pistons',
    image: pistons,
  },
  Toronto_Raptors: {
    name: 'Toronto Raptors',
    image: raptors,
  },
  Houston_Rockets: {
    name: 'Houston Rockets',
    image: rockets,
  },
  San_Antonio_Spurs: {
    name: 'San Antonio Spurs',
    image: spurs,
  },
  Minnesota_Timberwolves: {
    name: 'Minnesota Timberwolves',
    image: timberwolves,
  },
  Utah_Jazz: {
    name: 'Utah Jazz',
    image: utah,
  },
  Washington_Wizards: {
    name: 'Washington Wizards',
    image: wizards,
  },
};
export default listTeams;
